import React from 'react';
import DrawerBody from 'components/ui/DrawerBody';
import styled from 'styled-components';
import Spacer from 'components/ui/Spacer';
import { colors } from 'helpers/ColorHelper';

const SuccessPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
`;

const SuccessHeading = styled.div`
  font-size: 28px;
  color: ${colors.SPACE_GRAY};
  font-family: 'Circular-Black';
`;

const SuccessBody = styled.div`
  font-size: 16px;
  color: ${colors.MED_DARK_GRAY};
`;

export default props => {
  return (
    <DrawerBody background={props.background}>
      <SuccessPage>
        {props.headerImageSource}
        <Spacer mb={1}>
          <SuccessHeading>{props.headerText}</SuccessHeading>
        </Spacer>
        <Spacer mb={1}>
          <SuccessBody>{props.bodyText}</SuccessBody>
        </Spacer>
        <div>
          <Spacer mb={1}>
            <div>{props.cta}</div>
          </Spacer>
          <div>{props.secondaryCta}</div>
          <div>{props.thirdCta}</div>
          <Spacer mb={1}>
            <div>{props.fourthCta}</div>
          </Spacer>
        </div>
      </SuccessPage>
    </DrawerBody>
  );
};
